import Controller from "./deductionPlan.controller";
import template from "./deductionPlan.html";

const deductionPlan = {
  template,
  controller: Controller,
};

export default deductionPlan;



// WEBPACK FOOTER //
// ./src/pages/deductionPlan/deductionPlan.component.js